import { useState } from 'react';
import { UserOutlined } from '@ant-design/icons';

import { USER_PROFILE_PICTURE_BASE_URL } from '../../../utils/Constants';

const UserAvatar = ({ userId, size = 20 }) => {
  const [hasError, setHasError] = useState(false);
  const imageUrl = `${USER_PROFILE_PICTURE_BASE_URL}/${userId}/profile`;

  return (
    <div style={{ width: size, height: size }}>
      {!hasError ? (
        <img
          src={imageUrl}
          alt="User"
          width={size}
          height={size}
          style={{ borderRadius: '50%' }}
          onError={() => setHasError(true)}
        />
      ) : (
        <UserOutlined />
      )}
    </div>
  );
};

export default UserAvatar;
